import { Team } from '@air/next-icons';

import { LibraryDetailsAccessibility } from './LibraryDetailsAccessibility';

export const LibraryDetailsAccessibilityPublic = () => {
  return (
    <LibraryDetailsAccessibility
      description="Any workspace member can join this library"
      label="Public to workspace"
      icon={<Team className="size-4 fill-grey-10" />}
    />
  );
};
